export default __webpack_public_path__ + "static/media/europe-countries.6632a1d9.jpeg";